import { CreateAmbulatoryOrder } from 'domain/usecases/ambulatory/create-ambulatory-order'
import { NewAmbulatoryRepository } from 'repository/interfaces/new-ambulatory-repository'

export class RemoteCreateAmbulatoryOrder implements CreateAmbulatoryOrder {
  private readonly ambulatoryRepository: NewAmbulatoryRepository

  constructor(ambulatoryRepository: NewAmbulatoryRepository) {
    this.ambulatoryRepository = ambulatoryRepository
  }

  create(
    params: CreateAmbulatoryOrder.Params
  ): Promise<CreateAmbulatoryOrder.Model> {
    return this.ambulatoryRepository.createAmbulatoryOrder(params)
  }
}
